'use client';
import React, { useEffect, useRef, useState } from 'react';
import { getGlobalCounter } from '@/lib/gameStore';

export default function GlobalCounter() {
  const [displayCount, setDisplayCount] = useState(0);
  const targetRef = useRef(0);
  const animRef = useRef<number>(0);

  useEffect(() => {
    // Backend integration point: replace with real-time WebSocket or SSE from global DB counter
    const target = getGlobalCounter();
    targetRef.current = target;

    // Animate count up from 0
    const startTime = Date.now();
    const duration = 1800;
    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplayCount(Math.floor(eased * target));
      if (progress < 1) {
        animRef.current = requestAnimationFrame(animate);
      } else {
        setDisplayCount(target);
        // Simulate live increments
        const interval = setInterval(() => {
          targetRef.current += Math.floor(Math.random() * 3) + 1;
          setDisplayCount(targetRef?.current);
        }, 4000 + Math.random() * 3000);
        return () => clearInterval(interval);
      }
    };
    animRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animRef?.current);
  }, []);

  const formatted = displayCount?.toLocaleString('en-US');

  return (
    <div className="flex items-center justify-center gap-2 py-3 px-5 rounded-2xl"
      style={{ background: 'rgba(123,91,255,0.08)', border: '1px solid rgba(123,91,255,0.2)' }}>
      <span className="text-lg">🌍</span>
      <span className="font-mono-nums text-secondary font-bold text-lg">{formatted}</span>
      <span className="text-muted-foreground text-sm font-semibold">buttons pressed today</span>
    </div>
  );
}